import { countryFlag } from "../utils/countries";

export function ParticipantAvatar({ name, country, photoUrl, small = false }: { name: string; country?: string; photoUrl?: string; small?: boolean }) {
  const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join("").toUpperCase();
  return <span className={`participant-avatar ${small ? "small" : ""}`} title={`${name}${country ? ` · ${country}` : ""}`}>
    {photoUrl ? <img src={photoUrl} alt={`Foto de ${name}`} /> : <b>{initials}</b>}<i aria-label={country || "País no informado"}>{countryFlag(country)}</i>
  </span>;
}
